import { CardStyleInterpolators } from "@react-navigation/stack";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import React from "react";
import {
  RemoveNative2faRootParamList,
  SetupNative2faRootParamList,
} from "../../../../types";
import { Remove2faFormProvider } from "../../components/Remove2faForm/Remove2faFormProvider";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RemoveNative2faEnterCredentialsScreen } from "./RemoveNative2faEnterCredentialsScreen";
import { RemoveNative2faVerifyCodeScreen } from "./RemoveNative2faVerifyCodeScreen";

export type RemoveNative2faRootScreenProps = NativeStackScreenProps<
  SetupNative2faRootParamList,
  "RemoveNative2faRootScreen"
> & {};

export const RemoveNative2faRootScreen = ({
  navigation,
  route,
}: RemoveNative2faRootScreenProps) => {
  const Stack = createStackHeaderNavigator<RemoveNative2faRootParamList>();

  const { strategy } = route.params;

  return (
    <Remove2faFormProvider strategy={strategy}>
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
        }}
      >
        <Stack.Group
          screenOptions={{
            headerShown: false,
            headerLeft: () => <ModalCloseButton type="Back" />,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            title: "",
          }}
        >
          <Stack.Screen
            name="RemoveNative2faEnterCredentialsScreen"
            component={RemoveNative2faEnterCredentialsScreen}
          />
          <Stack.Screen
            name="RemoveNative2faVerifyCodeScreen"
            component={RemoveNative2faVerifyCodeScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </Remove2faFormProvider>
  );
};
